import { createSlice } from "@reduxjs/toolkit";
import {
  fetchUserById,
  fetchAllUsers,
  updateUserById,
  toggleUserStatus,
  deleteUserById,
  deleteUserAlls,
} from "./userThunks";

const initialState = {
  userData: null,
  userList: [],
  totalUsers: 0,
  totalPages: 1,
  loading: false,
  error: null,
  filters: {
    currentPage: 1,
    itemsPerPage: 10,
    searchQuery: "",
    sortColumn: "createdAt",
    sortOrder: "desc",
    statusFilter: "",
    roleFilter: "",
    startDate: null,
    endDate: null,
  },
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    clearUserData: (state) => {
      state.userData = null;
      state.error = null;
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetFilters: (state) => {
      state.filters = initialState.filters;
    },
  },
  extraReducers: (builder) => {
    builder
      // FETCH SINGLE USER
      .addCase(fetchUserById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserById.fulfilled, (state, action) => {
        state.userData = action.payload;
        state.loading = false;
      })
      .addCase(fetchUserById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // FETCH USERS LIST
      .addCase(fetchAllUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.userList = action.payload.users || [];
        state.totalUsers = action.payload.metadata.totalUsers || 0;
        state.totalPages = action.payload.metadata.totalPages || 1;
      })
      .addCase(fetchAllUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // UPDATE USER
      .addCase(updateUserById.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateUserById.fulfilled, (state, action) => {
        state.userData = action.payload;
        state.loading = false;
      })
      .addCase(updateUserById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // CHANGE STATUS
      .addCase(toggleUserStatus.pending, (state) => {
        // state.loading = true;
      })
      .addCase(toggleUserStatus.fulfilled, (state, action) => {
        const { id, status } = action.payload;
        const user = state.userList.find((u) => u._id === id);
        if (user) user.status = status;
        // state.loading = false;
      })
      .addCase(toggleUserStatus.rejected, (state, action) => {
        // state.loading = false;
        state.error = action.payload;
      })
      // DELETE USER
      .addCase(deleteUserById.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteUserById.fulfilled, (state, action) => {
        const deletedId = action.payload;
        state.userList = state.userList.filter((u) => u._id !== deletedId);
        state.loading = false;
      })
      .addCase(deleteUserById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // DELETE All USER
      .addCase(deleteUserAlls.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteUserAlls.fulfilled, (state, action) => {
        const deletedId = action.payload;
        state.loading = false;
      })
      .addCase(deleteUserAlls.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearUserData, setFilters, resetFilters } = userSlice.actions;
export default userSlice.reducer;
